module.exports = __webpack_public_path__ + "img/placeholder.554371b9.jpg";